export default __webpack_public_path__ + "static/media/legal-team-prosecutor.622e1598.jpg";